__turbopack_context__.v({
  "card": "ParagraphDarkTextMiniCards-module__AUrXDW__card",
  "cardBody": "ParagraphDarkTextMiniCards-module__AUrXDW__cardBody",
  "cardDesc": "ParagraphDarkTextMiniCards-module__AUrXDW__cardDesc",
  "cardIcon": "ParagraphDarkTextMiniCards-module__AUrXDW__cardIcon",
  "cardTitle": "ParagraphDarkTextMiniCards-module__AUrXDW__cardTitle",
  "cards": "ParagraphDarkTextMiniCards-module__AUrXDW__cards",
  "eyebrow": "ParagraphDarkTextMiniCards-module__AUrXDW__eyebrow",
  "grid": "ParagraphDarkTextMiniCards-module__AUrXDW__grid",
  "header": "ParagraphDarkTextMiniCards-module__AUrXDW__header",
  "headerImage": "ParagraphDarkTextMiniCards-module__AUrXDW__headerImage",
  "headerText": "ParagraphDarkTextMiniCards-module__AUrXDW__headerText",
  "section": "ParagraphDarkTextMiniCards-module__AUrXDW__section",
  "title": "ParagraphDarkTextMiniCards-module__AUrXDW__title",
});
